export default [
  {
    path: 'M512 749.226667l173.653333-48.213334 23.466667-260.266666H400.213333L392.533333 354.133333h324.266667l8.533333-84.906666H298.666667l23.893333 256.426666h293.973333l-9.813333 110.08-94.72 25.6-94.72-25.6-5.973333-70.826666h-85.333334l12.373334 136.106666L512 749.226667M173.653333 128h676.693334L789.333333 819.2 512 896l-277.333333-76.8L173.653333 128z',
    fill: '#E44D26',
  },
]
